import QueryStringUtil from 'utils/QueryStringUtil';

export default class NavigationUtil {
  /**
   * Navigate to another page optionally adding xNav query parameter
   * @param {string} url
   * @param {object} options - optional configurations
   * @property {object} options.xNav - details about the xNav which should be added
   * @property {string} options.xNav.pageZone - area of the page
   * @property {string} options.xNav.details - extra details to add to the xNav
   */
  static navigateTo(url, options = {}) {
    const {
      xNav,
    } = options;

    if (xNav !== undefined) {
      window.location = this.addXNav(url, xNav.pageZone, xNav.details);
    } else {
      window.location = url;
    }
  }

  static addXNav(url, pageZone, detail) {
    return QueryStringUtil.addOrReplaceParam(url, 'xnav', `DesignServicesHub_${pageZone}_${detail}`);
  }
}



// WEBPACK FOOTER //
// ./src/utils/NavigationUtil.js